import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import {
  selectFieldTitle,
  selectFieldTypeId,
  selectFieldLinks,
  selectFieldCostExecution,
  selectFieldMaxExecutions,
  selectDetailsCosts
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import * as formatter from 'mt-react-common/utils/formatter';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import TasksAccountSettingsService from '../../../../mt-react-common/modules/tasks/services/TasksAccountSettingsService';

// eslint-disable-next-line react/prefer-stateless-function
class TaskCardExample extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tasksAccountSettings: null
    };
  }

  componentDidMount() {
    this.leaveFromGroupRoom();
  }

  // Выйти из группы
  leaveFromGroupRoom = () => {
    TasksAccountSettingsService.getMySettings(this.props.reduxState).then(
      result => {
        if (result.response.status === 200) {
          this.setState({ tasksAccountSettings: result.destructData });
        }
      }
    );
  };

  render() {
    let taskStateBlock = null;
    if (this.state.tasksAccountSettings) {
      if (this.state.tasksAccountSettings.premoderationState === 1) {
        taskStateBlock = (
          <div>
            <span className="label label-light label-primary">
              {t('Премодерация')}
            </span>
            <p style={{ margin: '10px 0' }}>
              <span className="text-warning">
                {t(
                  'Перед публикацией, ваше задание должно пройти премодерацию. Для того, чтобы задание было сразу доступно для выполнения, достаточно пополнить баланс на 1000 рублей или более. Старайтесь создавать корректные задания, чтобы не лишиться этой возможности.'
                )}
              </span>
            </p>
          </div>
        );
      } else if (this.state.tasksAccountSettings.premoderationState === 2) {
        taskStateBlock = (
          <div>
            <span className="label label-light label-success">
              {t('Активно')}
            </span>
            <p style={{ margin: '10px 0' }}>
              <span className="text-warning">
                {t(
                  'Ваше задание сразу станет доступно для выполнения. Старайтесь создавать корректные задания, чтобы не лишиться этой возможности.'
                )}
              </span>
            </p>
          </div>
        );
      } else if (this.state.tasksAccountSettings.premoderationState === 3) {
        taskStateBlock = (
          <div>
            <span className="label label-light label-primary">
              {t('Премодерация')}
            </span>
            <p style={{ margin: '10px 0' }}>
              <span className="text-warning">
                {t(
                  'Перед публикацией ваше задание должно пройти премодерацию.'
                )}
              </span>
            </p>
          </div>
        );
      }
    } else {
      taskStateBlock = (
        <span className="label label-light label-success">{t('Активно')}</span>
      );
    }
    return (
      <React.Fragment>
        <div className="panel-heading panel-inner-border-bottom">
          <div className="task-table">
            <div className="task-cell">
              <h2 className="h3 task-title">
                <a title="Подписаться в инстаграме. Быстрая оплата та!">
                  {this.props.fieldTitle.value !== ''
                    ? this.props.fieldTitle.value
                    : t('Введите название задания')}
                </a>
              </h2>
            </div>
            <div className="task-cell task-price">
              <div className="task-price-val">
                <span className="h3">
                  {this.props.fieldCostExecution.value || 0}{' '}
                  <small>
                    <i className="fa fa-rub" />
                  </small>
                </span>
              </div>
            </div>
          </div>
          <ul className="list-inline task-info">
            <li className="text-muted">{formatter.dateFormat3()}</li>
            <li className="text-muted">ID{this.props.taskId}</li>
            {this.props.fieldLinks.value[0] ? (
              <li>
                <a
                  className="text-success text-underline"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={this.props.fieldLinks.value[0]}
                >
                  {this.props.fieldLinks.value[0]}
                </a>
              </li>
            ) : null}
          </ul>
        </div>
        <div className="panel-body">
          <div className="row offset_bottom offset_bottom_xs">
            <div className="col-xs-24 col-sm-12">
              <dl className="dl-options dl-options-sm dl-horizontal">
                <dt>{t('Категория')}:</dt>
                <dd>
                  {this.props.fieldTypeId.value
                    ? this.props.taskTypes[this.props.fieldTypeId.value]
                    : t('Не выбрано')}
                </dd>
                <dt>{t('Статус')}:</dt>
                <dd>{taskStateBlock}</dd>
                <dt>{t('Дата изменения')}:</dt>
                <dd>
                  <span className="text-success">
                    {formatter.dateFormat3()}
                  </span>
                </dd>
              </dl>
            </div>
            <div className="col-xs-24 col-sm-12">
              <dl className="dl-options dl-options-sm dl-horizontal border border-l">
                <dt>{t('Кол. выполнений')}:</dt>
                <dd>
                  <a>
                    {this.props.fieldMaxExecutions.value !== ''
                      ? this.props.fieldMaxExecutions.value
                      : 0}
                  </a>
                </dd>
                <dt>{t('Цена для заказчика')}:</dt>
                <dd>
                  <a>
                    {this.props.fieldCostExecution.value
                      ? parseFloat(this.props.fieldCostExecution.value).toFixed(
                          2
                        )
                      : parseFloat('0').toFixed(2)}{' '}
                    ₽
                  </a>
                </dd>
                <dt>{t('Цена для исполнителя')}:</dt>
                <dd>
                  <a>{this.props.detailsCosts.execCostForExecutor} ₽</a>
                </dd>
                <dt>&nbsp;</dt>
                <dd>&nbsp;</dd>
              </dl>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TaskCardExample.contextTypes = {
  router: PropTypes.shape()
};

TaskCardExample.propTypes = {
  // IN
  taskId: PropTypes.string.isRequired,
  // CONNECT
  fieldTitle: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired,
  fieldTypeId: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired,
  fieldCostExecution: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldMaxExecutions: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldLinks: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.array,
    errors: PropTypes.array.isRequired
  }).isRequired,
  detailsCosts: PropTypes.shape({
    totalSum: PropTypes.string,
    execCostForExecutor: PropTypes.string
  }).isRequired,

  taskTypes: PropTypes.shape({}).isRequired,
  reduxState: PropTypes.shape({}).isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({
  fieldTitle: selectFieldTitle(state, props.reducerName),
  fieldTypeId: selectFieldTypeId(state, props.reducerName),
  fieldCostExecution: selectFieldCostExecution(state, props.reducerName),
  fieldMaxExecutions: selectFieldMaxExecutions(state, props.reducerName),
  fieldLinks: selectFieldLinks(state, props.reducerName),
  detailsCosts: selectDetailsCosts(state, props.reducerName),
  taskTypes: getItemFromRefList(state, 'taskTypes'),
  reduxState: state
});

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch, props) => ({});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TaskCardExample)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CostsTaskInputs/TaskCardExample.js